function Footer() {
  return (
    <footer className="footer-section">
      <h2 className="footer-heading">"Defined by detail. Delivered with care."</h2>
      
     <div className="footer-email-box">
  <p>Feel free to reach us at:</p>

  <a 
    href="mailto:Asianelitehomecleaning.hyd@gmail.com"
    className="footer-email"
  >
    Asianelitehomecleaning.hyd@gmail.com
  </a>
</div>

      <div className="footer-container">
        <div className="footer-left">
          <h3>AsianElite Service</h3>
          <p>📞 <a href="tel:+919912298969">+91 9912298969</a></p>
          <p>📞 <a href="tel:+917093040178">+91 7093040178</a></p>
        </div>

        <div className="footer-middle">
          <h3>Locations</h3>
          <p>Hyderabad</p>
          <p>Secunderabad</p>
          <p>Bongloor Gate</p>
          <p>Hayathnagar</p>
          <p>Pedda Amberpet</p>
          <p>Kuntloor</p>
          <p>Nagole</p>
          <p>Vanasthalipuram</p>
          <p>Karmanghat</p>
          <p>Meerpet</p>
          <p>Nadergul</p>
        </div>

        <div className="footer-right">
          <h3>Services</h3>
          <p>Single Bedroom Cleaning</p>
          <p>Double Bedroom Cleaning</p>
          <p>Triple Bedroom Cleaning</p>
          <p>Kitchen Deep Cleaning</p>
          <p>Washroom Deep Cleaning</p>
          <p>Sofa Deep Cleaning</p>
          <p>Water Tank Cleaning</p>
          <p>Villa Duplex House</p>
          <p>Commercial Cleaning</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2015 AsianElite Service. All Rights Reserved.</p>
        <div className="footer-social">
         <a href="https://wa.me/917093040178" target="_blank" rel="noreferrer">WhatsApp</a>
<a href="https://www.facebook.com" target="_blank" rel="noreferrer">Facebook</a>
<a href="https://www.instagram.com" target="_blank" rel="noreferrer">Instagram</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;